<template>
    <div class="relative bg-white">
        <Hero
            :title="$t('golden_visa.hero.title')"
            :lead="$t('golden_visa.hero.lead')"
            :description="$t('golden_visa.hero.description')"
            :background-image="require('~/assets/images/illustrations/golden-visa/hero.png')"
            title-class="w-72 lg:w-72"
            secondary-type
        />

        {{/* * */}}
        {{/* * */}}
        {{/* * */}}
        {{/* Filipino workforce in Hungary */}}
        {{/* * */}}
        <div class="container text-black pb-20 md:pt-8">
            <div class="grid grid-cols-12 gap-5">
                <div class="col-span-12 md:text-lg lg:text-xl lg:text-center">
                    {{ $t('golden_visa.intro') }}
                </div>
            </div>

            <SectionWrapper :title="$t('golden_visa.advantages.title')" centered-title class="pt-16 md:pt-20">
                <div class="flex flex-col sm:flex-row sm:justify-between">
                    <ul class="grid grid-cols-1 gap-4 lg:gap-5">
                        <li
                            v-for="n in [1, 2, 3]"
                            :key="`advantage-${n}`"
                            class="relative title text-lg lg:text-xl col-span-2 md:col-span-1 pl-8"
                        >
                            <i class="absolute top-2 left-0 pi pi-check text-yellow-500 mr-2"></i>
                            {{ $t(`golden_visa.advantages.advantage_${n}`) }}
                        </li>
                    </ul>

                    <ul class="grid grid-cols-1 gap-4 lg:gap-5 mt-4 sm:mt-0">
                        <li
                            v-for="n in [4, 5, 6]"
                            :key="`advantage-${n}`"
                            class="relative title text-lg lg:text-xl col-span-2 md:col-span-1 pl-8"
                        >
                            <i class="absolute top-2 left-0 pi pi-check text-yellow-500 mr-2"></i>
                            {{ $t(`golden_visa.advantages.advantage_${n}`) }}
                        </li>
                    </ul>
                </div>
            </SectionWrapper>
        </div>

        {{/* * */}}
        {{/* * */}}
        {{/* * */}}
        {{/* Why indian workforce */}}
        {{/* * */}}
        <div class="bg-gray-100 text-black pt-16 md:pt-20 pb-16 md:pb-28 lg:pb-36">
            <SectionWrapper :title="$t('golden_visa.requirements.title')" centered-title class="container">
                <div class="grid grid-cols-12">
                    <div class="col-span-12 lg:col-span-8 lg:col-start-3">
                        <p class="sm:text-center mb-14">{{ $t('golden_visa.requirements.subtitle') }}</p>
                    </div>
                    <div class="col-span-12 lg:mt-8 xl:mt-0">
                        <div class="grid grid-cols-4 gap-x-5 gap-y-10 mx-auto mb-20 lg:mb-20">
                            <div class="col-span-4 sm:col-span-2 lg:col-span-1">
                                <h3 class="sm:text-center title title-base text-purple-400 mb-5">
                                    {{ $t('golden_visa.requirements.requirement_1.title') }}
                                </h3>
                                <p class="sm:text-center">
                                    {{ $t('golden_visa.requirements.requirement_1.description') }}
                                </p>
                            </div>

                            <div class="col-span-4 sm:col-span-2 lg:col-span-1">
                                <h3 class="sm:text-center title title-base text-purple-400 mb-5">
                                    {{ $t('golden_visa.requirements.requirement_2.title') }}
                                </h3>
                                <p class="sm:text-center">
                                    {{ $t('golden_visa.requirements.requirement_2.description') }}
                                </p>
                            </div>

                            <div class="col-span-4 sm:col-span-2 lg:col-span-1 lg:-mt-8 xl:mt-0">
                                <h3 class="sm:text-center title title-base text-purple-400 mb-5">
                                    {{ $t('golden_visa.requirements.requirement_3.title') }}
                                </h3>
                                <p class="sm:text-center">
                                    {{ $t('golden_visa.requirements.requirement_3.description') }}
                                </p>
                            </div>

                            <div class="col-span-4 sm:col-span-2 lg:col-span-1">
                                <h3 class="sm:text-center title title-base text-purple-400 mb-5">
                                    {{ $t('golden_visa.requirements.requirement_4.title') }}
                                </h3>
                                <p class="sm:text-center">
                                    {{ $t('golden_visa.requirements.requirement_4.description') }}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </SectionWrapper>
        </div>

        {{/* * */}}
        {{/* * */}}
        {{/* * */}}
        {{/* Filipino workforce in Hungary */}}
        {{/* * */}}
        <div class="relative pt-16 lg:pt-20 pb-16 lg:pb-36 xl:pb-48 bg-gray-800 text-white">
            <div class="container">
                <SectionWrapper :title="$t('golden_visa.obtain.title')" centered-title>
                    <div class="grid grid-cols-1 gap-y-5 md:gap-y-16 lg:gap-y-20 pt-5 sm:pt-12">
                        <FeatureCard
                            :index="1"
                            :title="$t('golden_visa.obtain.section_1.title')"
                            :illustration="require('~/assets/images/illustrations/golden-visa/1.jpg')"
                            :decorator="require('~/assets/images/illustrations/decoration-07.svg')"
                            rounded-b-r
                            with-contact-button
                            with-gap-between-text-and-image
                        >
                            <div class="tinymce-content" v-html="$t('golden_visa.obtain.section_1.description')"></div>
                        </FeatureCard>

                        <FeatureCard
                            :index="2"
                            :title="$t('golden_visa.obtain.section_2.title')"
                            :illustration="require('~/assets/images/illustrations/golden-visa/2.jpg')"
                            :decorator="require('~/assets/images/illustrations/decoration-08.svg')"
                            reversed
                            rounded-t-l
                            with-contact-button
                            with-gap-between-text-and-image
                        >
                            <div class="tinymce-content" v-html="$t('golden_visa.obtain.section_2.description')"></div>
                        </FeatureCard>

                        <FeatureCard
                            :index="3"
                            :title="$t('golden_visa.obtain.section_3.title')"
                            :illustration="require('~/assets/images/illustrations/golden-visa/3.jpg')"
                            :decorator="require('~/assets/images/illustrations/decoration-07.svg')"
                            rounded-t-r
                            with-contact-button
                            with-gap-between-text-and-image
                        >
                            <div class="tinymce-content" v-html="$t('golden_visa.obtain.section_3.description')"></div>
                        </FeatureCard>

                        <FeatureCard
                            :index="4"
                            :title="$t('golden_visa.obtain.section_4.title')"
                            :illustration="require('~/assets/images/illustrations/golden-visa/4.jpg')"
                            :decorator="require('~/assets/images/illustrations/decoration-08.svg')"
                            rounded-t-l
                            reversed
                            with-contact-button
                            with-gap-between-text-and-image
                        >
                            <div class="tinymce-content" v-html="$t('golden_visa.obtain.section_4.description')"></div>
                        </FeatureCard>

                        <FeatureCard
                            :index="5"
                            :title="$t('golden_visa.obtain.section_5.title')"
                            :illustration="require('~/assets/images/illustrations/golden-visa/5.jpg')"
                            :decorator="require('~/assets/images/illustrations/decoration-07.svg')"
                            rounded-t-r
                            with-contact-button
                            with-gap-between-text-and-image
                        >
                            <div class="tinymce-content" v-html="$t('golden_visa.obtain.section_5.description')"></div>
                        </FeatureCard>
                    </div>
                </SectionWrapper>

                <div
                    class="sm:text-center sm:max-w-xl lg:max-w-2xl sm:mx-auto lg:pt-8 xl:pt-24"
                    v-html="$t('our_services.continuous_updates_text')"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
import Hero from '@/components/Heroes/Hero';
import FeatureCard from '@/components/Cards/FeatureCard/FeatureCard';
import SectionWrapper from '@/components/UI/SectionWrapper';

export default {
    name: 'FilipinoWorkforce',
    components: {
        Hero,
        FeatureCard,
        SectionWrapper,
    },
    asyncData({ i18n, localePath, redirect }) {
        if (i18n.locale !== 'en') {
            return redirect(localePath('/'));
        }
    },
};
</script>

<style scoped></style>
